const ROLES = {
  SCTK: "ROLE_USER_GLOBAL_SCTK_ALL",
  RELEASE_MANAGEMENT: "ROLE_USER_GLOBAL_RELEASE_MANAGEMENT_ALL",
  MULTI_DEPLOYMENT: "ROLE_USER_GLOBAL_MULTI_DEPLOYMENT_ALL",
  AWS_SECRETS_MANAGER: "ROLE_USER_ITAAP_AWS_SECRETS_MANAGER_ALL",
  AWS_PARAMETER_STORE_MANAGER: "ROLE_USER_ITAAP_AWS_PARAMETER_STORE_MANAGER_ALL",
  AWS_CACHE_MANAGER: "ROLE_USER_ITAAP_AWS_CACHE_MANAGER_ALL",
  IAC_TFSTATE_UNLOCK: "ROLE_USER_GLOBAL_IAC_TFSTATE_UNLOCK_ALL",
  UTILS: "ROLE_USER_GLOBAL_UTILS_ALL",
  ROLE_MANAGEMENT: "ROLE_USER_ADMIN_ROLE_MANAGEMENT_ALL",
  USER_MANAGEMENT: "ROLE_USER_ADMIN_USER_MANAGEMENT_ALL",
  TENANT_MANAGEMENT: "ROLE_USER_ADMIN_TENANT_MANAGEMENT_ALL",
  AI_MODE: "ROLE_USER_GLOBAL_AI_MODE_ALL",
  AI_MODE_SDLC: "ROLE_USER_GLOBAL_AI_MODE_SDLC_ALL",
  AI_CHAT_AGENT: "ROLE_USER_GLOBAL_AI_CHAT_AGENT_ALL",
  AI_SETTINGS: "ROLE_USER_GLOBAL_AI_SETTINGS_ALL"

};

export default ROLES;